import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { Button } from 'antd';
import './extraWindow.css';

// Escape clipped/scrolling parents and follow Safari's visible viewport, not its layout viewport.
export default function ExtraWindow({ title, saving, canEdit = true, onCancel, onSave, saveLabel = 'Save', children }) {
  const ref = useRef(null);
  useEffect(() => {
    const viewport = window.visualViewport;
    const adjust = () => {
      const root = ref.current;
      if (!root) return;
      root.style.setProperty('--extra-top', `${viewport?.offsetTop || 0}px`);
      root.style.setProperty('--extra-height', `${viewport?.height || window.innerHeight}px`);
    };
    adjust();
    viewport?.addEventListener('resize', adjust);
    viewport?.addEventListener('scroll', adjust);
    window.addEventListener('resize', adjust);
    const escape = e => { if (e.key === 'Escape' && !saving) onCancel(); };
    document.addEventListener('keydown', escape);
    return () => {
      viewport?.removeEventListener('resize', adjust); viewport?.removeEventListener('scroll', adjust);
      window.removeEventListener('resize', adjust); document.removeEventListener('keydown', escape);
    };
  }, [saving, onCancel]);
  return createPortal(<div ref={ref} className="extra-window-overlay">
    <section className="extra-window" role="dialog" aria-modal="true" aria-label={title}>
      <header className="extra-window-header"><Button disabled={saving} onClick={onCancel}>Cancel</Button><h2>{title}</h2>{canEdit && <Button type="primary" loading={saving} onClick={onSave}>{saveLabel}</Button>}</header>
      <div className="extra-window-content">{children}</div>
    </section>
  </div>, document.body);
}